<template>
    <div class="edit_product_details" :data-indicador="indicador">
        <div class="product_item_details" v-html="product.product_desc" :data-indicador="indicador" v-if="!editActive && validDesc" @click.prevent="activeEdit()"></div>
        <div class="content-editor" v-else>
            <!-- limpiar barras invertidas -->
            <textarea
                v-model="product.product_desc"
                class="widget_edit_product_details"
                :placeholder="lang.bsed_add_description_ph"
                maxlength="500"
                ref="editDetails_product"
                @change="saveProductDetails()"
                @focusout="inactiveEdit"
            ></textarea>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props: ['indicador', 'product'],
    data(){
        return {
            loadSave: false,
            editActive: false,
            apis: null,
            lang: {
                bsed_add_description_ph: '',
                bs_error: '',
                bs_could_not_save: '',
            },
        };
    },
    created(){
        let t = this;
        t.lang = t.$store.getters['ModApps/Marketea/lang'];
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            langGetter: "lang",
        }),
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
    },
    methods: {
        // limpiar todas las barras invertidas
        clearText(text) {
            if (!text) return '';
                return text
                    .replace(/\\\\+/g, '\\') // reduce múltiples barras
                    .replace(/\\'/g, "'")
                    .replace(/\\"/g, '"')
                    .replace(/\\n/g, '\n')
                    .replace(/\\r/g, '\r')
                    .replace(/\\t/g, '\t');
        },
        activeEdit(){
            let t = this;
            t.editActive = true;
            this.product.product_desc = this.clearText(this.product.product_desc);
            setTimeout(() => {
                if(t.$refs.editDetails_product){
                    t.$refs.editDetails_product.focus();
                }
            }, 200);
        },
        inactiveEdit(){this.editActive = false;},
        noEnter(e){
            let t = this;
            var code = (e.which) ? e.which : e.keyCode;
            if(code == 13){
                e.preventDefault();
                t.saveProductDetails()
            }
        },
        saveProductDetails(){
            let t= this;
            t.inactiveEdit()
            let urlService = t.apis.set(3)// setProduct
            if(!t.loadSave){
                t.loadSave = true;
                // @ts-ignore
                window.master.post(urlService, t.product)
                .then((response) => {
                    console.log(urlService, t.product, response.data);
                    t.loadSave = false;
                })
                .catch((error) => {
                    console.log(error);
                    t.loadSave = false;
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: t.lang.bs_error,
                        text: t.lang.bs_could_not_save,
                    });
                });
            }
        },
    },
    computed: {
        validDesc: function(){
            let t = this;
            return (t.product.product_desc && t.product.product_desc.trim().length>0);
        },
    }
}
</script>
<style lang="scss" scoped>
    .edit_product_details {
        .product_item_details{
            border: 1px dashed transparent;
            &:hover{
                border: 2px dashed #edd340;
                border-radius: 4px;
            }
        }
        textarea.widget_edit_product_details{
            width: 100%;
            min-height: 80px;
            font-size: 0.8rem;
            font-weight: normal;
            color: #8e8e8e;
            font-family: Arial, Helvetica, sans-serif;
            color: #000;
            text-align: left;
            padding: 5px;
            resize: none;
            box-shadow: none;
            outline: none;
            margin-top: 10px;
            border: 1px solid #fafafa;
            &:focus {
                border-color: light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
            }
            &::placeholder {
                color: #c4c4c4;
                font-weight: 400;
            }
        }
    }
</style>
